import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconFiles } from "@tabler/icons-react";
import { Button, Group, PageHeader } from "@/components/ui";
import type { SolicitudDetalle } from "@/lib/types";

/**
 * Header del detalle de autorización · breadcrumbs + acciones (Ver archivos
 * de la solicitud · Volver a la bandeja).
 */
export function AutorizacionDetalleHeader({ sol }: { sol: SolicitudDetalle }) {
  const navigate = useNavigate();
  return (
    <PageHeader
      title={`Autorización · Solicitud ${sol.folio}`}
      description={`${sol.tipo} / ${sol.subtipo} · ${sol.organizacion?.nombre ?? "—"} · estado ${sol.estado}`}
      breadcrumbs={[
        { label: "Inicio", href: "/dashboard" },
        { label: "Autorización", href: "/autorizacion/bandeja" },
        { label: sol.folio },
      ]}
      actions={
        <Group gap="xs">
          <Button
            variant="default"
            leftSection={<IconFiles size={14} />}
            onClick={() =>
              void navigate({
                to: "/solicitudes/$id/documentos",
                params: { id: sol.id },
              })
            }
          >
            Ver archivos
          </Button>
          <Button
            variant="default"
            leftSection={<IconArrowLeft size={14} />}
            onClick={() => void navigate({ to: "/autorizacion/bandeja" })}
          >
            Bandeja
          </Button>
        </Group>
      }
    />
  );
}
